import React from "react";

const ClientBenefits = () => {
  const benefitCards = [
    {
      text: "Reduce time-to-value from months to weeks",
    },
    {
      text: "Launch campaigns faster and with better targeting",
    },
    {
      text: "Migrate legacy platforms with lower risk",
    },
    {
      text: "Build internal capability to scale GenAI across departments",
    },
  ];

  return (
    <div className="w-full bg-gray-100 py-16 lg:py-14 lg:pb-12">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-12 lg:mb-16">
          <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-[#0A1931] RoobertLight leading-[120%] mb-4">
            The result? Less drag.
            <br />
            More speed. Real results.
          </h2>
          <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-[#0A1931] RoobertMedium leading-[120%]">
            We help clients:
          </h3>
        </div>

        {/* Benefit Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-16 mb-12 lg:mb-14">
          {benefitCards.map((card, index) => (
            <div
              key={index}
              className="bg-white p-6 lg:p-8 flex flex-col justify-center relative"
            >
              <p className="text-black RoobertMedium text-[16px] lg:text-[18px] leading-[140%]">
                {card.text}
              </p>
              <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-1/3 h-1/2"></div>
            </div>
          ))}
        </div>

        {/* Call-to-Action Section */}
        <div className="mb-8">
          <p className="text-[#0A1931] RoobertRegular text-[16px] lg:text-[18px] leading-[140%] mb-6">
            And we do it in partnership - with clarity, collaboration, and measurable impact.
          </p>
          
          {/* Call-to-Action Button */}
          <button className="bg-[#66FF00] text-black px-8 py-4 RoobertSemiBold text-[16px] lg:text-[18px] hover:bg-[#5AE600] transition-colors duration-200 tracking-wider">
            Schedule a meeting with us
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientBenefits;
